export default __webpack_public_path__ + "static/media/Shopping.e73d5c6f.svg";